import { useCallback, useEffect, useState } from "react";

/**
 * Custom hook to check if the browser tab is currently active (visible).
 * @returns {boolean} True if the tab is visible, false otherwise.
 */
const useIsTabActive = () => {
  const [isTabVisible, setIsTabVisible] = useState(true);

  // Callback function to handle the visibility change event
  const handleVisibilityChange = useCallback(() => {
    // document.visibilityState will be 'visible' or 'hidden'
    setIsTabVisible(document.visibilityState === "visible");
  }, []);

  useEffect(() => {
    // Add event listener when the component mounts
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleVisibilityChange]); // Re-run effect if handleVisibilityChange changes

  return isTabVisible;
};

export default useIsTabActive;
